import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import InfoIcon from '~/components/svg/InfoIcon'
import QuestionIcon from '~/components/svg/QuestionIcon'

const TooltipContainer = styled.button.attrs({ type: 'button' })`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  margin: ${props => props.margin};
  text-decoration: none;
  cursor: default;
  padding: 0;
  background: rgba(255, 255, 255, 0);
  border: none;
  outline: none;
  vertical-align: middle;
  flex-shrink: 0;
  line-height: 0;
  right: ${props => props.right || 0}px;
  top: ${props => props.top || 0}px;
`

const MessageContainer = styled.div`
  position: absolute;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  font-size: .9rem;
  line-height: 1rem;
  width: 226px;
  background-color: #919191;
  color: #fff;
  text-align: center;
  padding: 8px;
  z-index: 5;
  user-select: none;
  bottom: ${props => props.size + 5}px;
  right: ${props => (props.offsetX || -113) + (props.size / 2)}px;

  &::after {
  content: "";
  position: absolute;
  top: 100%;
  left: ${props => props.decorationOffsetX ? props.decorationOffsetX : "50%"};
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #919191 transparent transparent transparent;
  }
`

class Tooltip extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showing: false
    }
  }

  setShowing = bool => {
    this.setState({ showing: bool })
  }

  get icon() {
    const ICONS = {
      info: InfoIcon,
      question: QuestionIcon
    }
    if (ICONS[this.props.icon]) return ICONS[this.props.icon]
    return ICONS.info
  }

  render() {
    return (
      <TooltipContainer
        size={this.props.size}
        margin={this.props.margin}
        top={this.props.top}
        right={this.props.right}
        onClick={() => this.setShowing(!this.state.showing)}
      >
        <this.icon size={this.props.size} />
        {this.state.showing ? (
          <MessageContainer 
            size={this.props.size} 
            offsetX={this.props.offsetX} 
            decorationOffsetX={this.props.decorationOffsetX}
          >
            {this.props.children || this.props.message}
          </MessageContainer>
        ) : null}
      </TooltipContainer>
    )
  }
}

Tooltip.propTypes = {
  message: PropTypes.string,
  icon: PropTypes.oneOf(['info', 'question']),
  size: PropTypes.number,
  margin: PropTypes.string
}

Tooltip.defaultProps = {
  message: null,
  icon: 'info',
  size: 18,
  margin: '0 0 0 10px'
}

export default Tooltip
